module.exports = __webpack_public_path__ + "static/media/Large-Triangles.7ec56c81.svg";